import type { FC } from "react";
import { ActivityGroupRow } from "web_myplann/Activities/Components/ActivityGroupRow";
import type { ActivityOrTaskListItem } from "web_myplann/Activities/Helpers/isActivityListItem";
import type { EventRowVariant } from "web_myplann/Shared/Types/EventRowVariant";

type Props = {
	items: ActivityOrTaskListItem[];
	showPerson: boolean;
	variant?: EventRowVariant;
};

export const ActivityGroupRows: FC<Props> = ({
	items,
	showPerson,
	variant,
}) => (
	<>
		{items.map((item, index) => (
			<ActivityGroupRow
				key={item.id}
				item={item}
				showDivider={index < items.length - 1}
				showPerson={showPerson}
				variant={variant}
			/>
		))}
	</>
);
